import { lazy } from 'react'

const QosPlot = {
  ControlPlot: lazy(() => import('./ControlPlot')),
  CreatePlot: lazy(() => import('./CreatePlot'))
}

export default QosPlot